export default __webpack_public_path__ + "static/Header-eff4ff288a0aec339df0ed558ae883fd.jpg";